import { RentalAdvert, SaleAdvert } from '../types/types';
import { BooleansOf } from '../utils/types';

export const GeneralRentalBooleans : () => BooleansOf<RentalAdvert>[] = () =>(
  [
    'freeStanding', 'nonSmoking', 'hasLocalContact', 'wheelchairAccessible',
    'isHistorical', 'isBackToBasic', 'isEcological', 'isLargeGroups', 'isChildrenSafe', 'isAdultsOnly'
  ]
)

export const InteriorRentalBooleans  : () => BooleansOf<RentalAdvert>[] = () => (
  [
    'hasDishwasher','hasWashingMachine','hasWashDryer','hasIron','hasVegetableGarden','hasFencedGarden','allowsPets',
    'hasBabysitter','hasChildBed','hasChildChair','hasPlayingRoomOutside','hasTennisAtObject',
    'tableDHotes','familyRoom','hasTv','hasInternet','hasCourseRoom','hasBoatAtObject','hasBikeAtObject',
    'hasFireplace','hasHairDryer','hasBath','hasSauna','hasJacuzzi','hasAirco','hasSwimmingpool',
    'hasPoolInside','hasHeatedPool','hasPrivatePool',
  ]
)

export const SurroundingsRentalBooleans  : () => BooleansOf<RentalAdvert>[] = () => (
  [
    'nearCountrySide', 'nearMountains', 'nearHills', 'nearForest', 'nearVillage', 'nearCity',
    'nearPublicTransport', 'onCamping','onVineyard','onFarm','nearBeach','nearWater',
  ]
)

export const ActivitiesRentalBooleans  : () => BooleansOf<RentalAdvert>[] = () => (
  [
    'nearSkiing', 'hasGolfcourse', 'nearBike', 'hasActivitiesProgram', 'nearHiking', 'nearMountainbike',
    'nearHorseriding', 'nearThemepark', 'nearFishsport', 'nearWatersports', 'nearMountainsports', 'nearFlying',
    'hasPaintingCourse', 'hasYoga', 'hasPottery', 'hasOtherCourses', 'nearLanglauf',
  ]
)

export const GeneralSaleBooleans  : () => BooleansOf<SaleAdvert>[] = () => (
  [
    'isFreeStanding', 'hasSwimmingpool', 'onCamping', 'hasFireplace',
    'tennisAtObject'
  ]
)

export const InteriorSaleBooleans  : () => BooleansOf<SaleAdvert>[] = () => (
  [
    'hasFireplace', 'wheelchairAccessible', 'tennisAtObject', 'hasSwimmingpool'

  ]
)

export const ActivitiesSaleBooleans  : () => BooleansOf<SaleAdvert>[] = () => (
  [
    'nearBike','nearGolf','nearSkiing','nearHiking','nearMountainbike','nearWatersports',
     'nearMountainsports','nearFishsport','nearHorseriding'

  ]
)

export const SurroundingsSaleBooleans  : () => BooleansOf<SaleAdvert>[] = () => (
  [
    'nearVillage', 'nearCity', 'nearForest', 'nearCountrySide', 'nearMountains', 'nearHills',
    'nearThemepark', 'onVineyard', 'nearBeach', 'nearWater', 'nearPublicTransport'

  ]
)
